import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION = gql `
  mutation SetWarehouseReleaseModel($modelSpecificationId: String!, $warehouseReleaseId: String!) {
    setWarehouseReleaseModel(
      modelSpecificationId: $modelSpecificationId
      warehouseReleaseId: $warehouseReleaseId
    ) {
      warehouseReleaseModel {
        id
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION;
